// Thunks extracted from Services.js

import _ from "lodash";
import axios from "lib/axiosInstance";
import axiosLib from "axios";
import update from "immutability-helper";
import { DEFAULT_LINK_THUMB_URL } from "store/static";
import { push, replace } from "services/NavigationService";
import moment from "moment";
import client from "lib/apolloClient/client";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import {
  getRelativePath,
  ATTACHMENT_WARNINGS,
  getFileExtensionFromMimeType,
  generateRandomId,
  getBackendServerUrl,
  htmlToText,
  dispatchError,
  getCurriculumProgramIdFromState,
  getFileExtension,
  AESEncrypt,
} from "Utils";
import { MimeDb, USER_TYPE_ENTITY_MAPPING } from "Constants";
import {
  signS3URLMutation,
  bulkSignS3URLMutation,
  generateResourceLabelForExistingResourcesMutation,
  updateAttachmentAndBulkActivateResourcesMutation,
  scrapeUrlMutation,
  markCommentsReadForFieldMutation,
  createAttachmentMutation,
  deleteAttachmentMutation,
  updateBasicUserDetailsMutation,
  createPlanUpgradeRequestMutation,
  bulkUploadByFileMutation,
  generateZoomRefreshTokenMutation,
  createAttachmentGroupsMutation,
  createAttachmentGroupsMutationV2,
  deleteAttachmentGroupsMutation,
  addApiEventMutation,
  generateThirdPartyRefreshTokenMutation,
  sendSigninLinkMutation,
  createOrganizationGlobalConstantsMutation,
  acceptTurnitinEulaMutation,
  updateEntityIsReadMutation,
  convertPdfToWorkbookMutation,
  updateEntityIsReadInBulkMutation,
  createAIMessageMutation,
  resetAIConversationMutation,
  updateAIMessageMutation,
  reorderAttachmentGroupMutation,
} from "modules/CommonMutations";
import {
  getTotalCommentOfNodeQuery,
  getUserZoomAuthorizedStatusQuery,
  getUserThirdPartyAuthorizedStatusQuery,
  getUserThirdPartyPickerTokensQuery,
  getOrganizationGlobalConstantsQuery,
  getTurnitinReportViewerLaunchUrlQuery,
  getIsTurnitinEulaRequiredQuery,
} from "modules/CommonQuery";
import {
  getCommentsOfNodeFromCache,
  writeCommentNodeFragment,
  getAttachmentOfNodeFromCache,
  writeAttachmentNodeFragment,
  getCriteriaSetSlimDetailsFromCache,
  getOrganizationConstantsFromCache,
  getUserBasicDetailsFromCache,
  writeUserBasicDetailsFromCache,
  getAttachmentGroupsOfNodeFromCache,
  writeAttachmentGroupsOfNodeInCache,
  getAttachmentFragmentFromCache,
  writeAttachmentSimilarityReportInCache,
  getOrganizationCurriculumProgramsFromCache,
  getAIConversationsFromCache,
  writeAIConversationsInCache,
} from "modules/CommonGraphqlHelpers";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import {
  getUserInfo,
  getDecodedToken,
} from "Login/modules/LoginModule/LoginUtils";
import ACLStore from "lib/aclStore";
import { Sentry } from "services/sentry";
import querystringify from "querystringify";

import { getCurrentCurriculumProgramType } from "modules/CommonSelectors";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import { setConfigurationValueForEntityIdsAndTypeMutation } from "../../QueryMutationFragment/CommonQueryMutationFragment/mutations";
import { getConfigurationQuery } from "ChildrenPage/modules/ChildrenPageQuery";
import { getStreamBackendUrl, getWebSocketUrl } from "Utils/UrlHelpers";
import { getFileExtensionFromFilename } from "Utils/AttachmentHelpers";
import { allowURLWithCredentials } from "Utils/SecureUrlHelpers";
import {
  setIsAIUsageLimitModalOpen,
  setProgress,
  toggleActionLoading,
  removeProgressElement,
} from "./ServicesActions";
import {
  PATH_TO_GET_SIGNED_URL,
  CancelToken,
  getExceededSizeToastMsgAndLocaleParams,
  checkCriteriaSetOfPypTypeInLevelsLocalMemoize,
  isExcludedParentTypesForAttachmentCache,
  getCombinedLocationSearch,
  getMutationVariable,
  getIsVirusTaggingEnabled,
  isBufferHeic,
  parseStreamResponse,
  getDefaultTTSModel,
  makeStreamRequest,
  isWebSocketCancel,
  isChinaAIEnhancedSetupEnabled,
  isAudioServicesChinaSetupEnabled,
} from "./ServicesUtils";
import {
  getOverriddenModelFromLocalStorage,
  AI_SDK_REGION_FLAG_MAP,
} from "Utils/AIUtils";
import { convertRecordedBlobToBase64 } from "Utils/AudioRecorderHelpers";
import { parseSpeechOperationsResponse } from "@toddle-edu/common-utils";
import { GENERATE_USING_AI } from "Worksheet/modules/WorksheetConstants";

// Thunk Helpers
// `dispatchUpdateFieldMutationFunc`, `debouncedDispatchUpdateFieldMutation`,
// `updateFieldMutationFunc`, and `updateField` were moved to
// `src/modules/FieldUpdateThunks.js`.

// `trackFeatureActivationEvents`, `handleFeatureActivation`,
// `checkAndClearActiveFeatureWithKeyboardShortcuts`,
// `handleGlobalKeyboardEvents`, `handleGlobalSearch`,
// `_handleHomePageNavigation`, and `_goToPlatformHomeRoute` were moved to
// `src/modules/GlobalKeyboardThunks.js`.

// Thunks
export const checkTermsExistsForCurrentCurriculumProgram = ({
  curriculumProgramId: curriculumProgramIdParam,
} = {}) => {
  return (dispatch, getState) => {
    // if feature flag is not enabled, return true
    const state = getState();
    const isToddleLibrary = state.login.activeTab == "TODDLE_LIBRARY";

    if (!ACLStore.can("FeatureFlag:EnableTermRestriction") || isToddleLibrary) {
      return true;
    }

    const userInfo = getUserInfo({ portalType: "PLANNER" });
    const organizationId = _.get(userInfo, "org_id");
    const curriculumProgramId =
      curriculumProgramIdParam || getCurriculumProgramIdFromState({ state });
    const orgCurriculumPrograms = getOrganizationCurriculumProgramsFromCache(
      organizationId
    );

    let curriculumProgram;
    if (!_.isEmpty(curriculumProgramId)) {
      curriculumProgram = _.find(
        _.get(orgCurriculumPrograms, "curriculumPrograms", []),
        {
          id: curriculumProgramId,
        }
      );
    } else {
      curriculumProgram = _.find(
        _.get(orgCurriculumPrograms, "curriculumPrograms", []),
        item => _.get(item, "type") === CURRICULUM_TYPE_PYP
      );
    }

    const termsCount = _.get(curriculumProgram, "terms.totalCount", 0);
    return termsCount > 0;
  };
};

// `writeConfigDataToCache`, `updateCustomCoursesCacheOnReset`,
// `dispatchAttendanceAutoMarkingMutation`, `updateConfigurationData`,
// `updatePreferenceData`, and `updateSettings` (plus their private helpers
// `segregateSettingsByType`, `buildMutationInput`, `handlePostUpdate`,
// `applyOptimisticConfigurationUpdate`, `updateSettingsV2`) were moved to
// `src/modules/ConfigurationThunks.js`.

export const updateConfigurationDataForEntityIds = ({
  configId,
  entityType,
  includedEntityIds,
  excludedEntityIds,
  configurationQueryVariables,
} = {}) => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: setConfigurationValueForEntityIdsAndTypeMutation,
        variables: {
          input: {
            configId,
            entityType,
            includedEntityIds,
            excludedEntityIds,
          },
        },
        refetchQueries: configurationQueryVariables
          ? [
              {
                query: getConfigurationQuery,
                variables: configurationQueryVariables,
              },
            ]
          : [],
        awaitRefetchQueries: !!configurationQueryVariables,
      });

      const success = _.get(
        res,
        "data.platform.setConfigurationValueForEntityIdsAndType",
        false
      );
      if (!success) {
        dispatchError({
          dispatch,
          e: new Error(
            "setConfigurationValueForEntityIdsAndType returned false"
          ),
        });
      }
      return res;
    } catch (e) {
      console.error(e, "updateConfigurationDataForEntityIds error");
      dispatchError({ dispatch, e });
    }
  };
};

export const addApiEvent = params => {
  return async (dispatch, getState) => {
    try {
      const userLoggedIn = _.get(getState(), "login.userLoggedIn");

      if (!userLoggedIn) return;

      await client.mutate({
        mutation: addApiEventMutation,
        variables: params,
      });
    } catch (e) {
      console.error(e);
    }
  };
};

export const createPlanUpgradeRequest = ({ screen }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(toggleActionLoading(true));
      await client.mutate({
        mutation: createPlanUpgradeRequestMutation,
        variables: {
          screen,
          portalType: "PLANNER",
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:request_successfully_sent",
          type: "success",
          position: "toast-bottom-right",
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    } finally {
      dispatch(toggleActionLoading(false));
    }
  };
};

export const getUserThirdPartyAuthorizedStatus = ({ serviceType }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const userType = userInfo.user_type;
    const userEntityType = _.get(
      USER_TYPE_ENTITY_MAPPING[userType],
      "entityType",
      ""
    );
    const skipAccessToken = serviceType === "ZOOM";
    try {
      const response = await client.query({
        query: getUserThirdPartyAuthorizedStatusQuery,
        variables: {
          id: userId,
          type: userEntityType,
          serviceType,
          skipAccessToken,
        },
        fetchPolicy: "network-only",
      });
      return _.last(_.get(response, "data.node.linkedThirdPartyAccounts", []));
    } catch (e) {
      return false;
    }
  };
};

export const getUserThirdPartyPickerTokens = ({ serviceType }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const userType = userInfo.user_type;
    const userEntityType = _.get(
      USER_TYPE_ENTITY_MAPPING[userType],
      "entityType",
      ""
    );
    try {
      const response = await client.query({
        query: getUserThirdPartyPickerTokensQuery,
        variables: {
          id: userId,
          type: userEntityType,
          serviceType,
        },
        fetchPolicy: "network-only",
      });
      const data = _.get(
        response,
        "data.node.linkedThirdPartyAccountFilePickerTokens.data"
      );
      if (
        !_.get(data, "isConnected", false) &&
        _.isEmpty(_.get(data, "graphAccessToken", ""))
      ) {
        return { initiateAuth: true };
      }
      return { data, initiateAuth: false };
    } catch (e) {
      if (
        e.message === `${serviceType}_ACCOUNT_NOT_LINKED` ||
        e.message === `${serviceType}_ACCOUNT_NOT_WORKING`
      ) {
        //redirect to account connect flow
        return { initiateAuth: true };
      }
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return { initiateAuth: false };
    }
  };
};

export const getUserZoomAuthorizedStatus = () => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    try {
      const response = await client.query({
        query: getUserZoomAuthorizedStatusQuery,
        variables: {
          id: userId,
        },
        fetchPolicy: "network-only",
      });
      return _.get(response, "data.node.isZoomAuthorized", false);
    } catch (e) {
      return false;
    }
  };
};

export const generateZoomRefreshToken = ({ accessCode, redirectUri }) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: generateZoomRefreshTokenMutation,
        variables: {
          accessCode,
          redirectUri,
        },
      });
      return _.get(response, "data.platform.generateZoomRefreshToken", false);
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const generateThirdPartyRefreshToken = ({
  accessCode,
  redirectUri,
  serviceType,
}) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: generateThirdPartyRefreshTokenMutation,
        variables: {
          accessCode,
          redirectUri,
          serviceType,
        },
      });
      return _.get(
        response,
        "data.platform.generateThirdPartyRefreshToken.response",
        {}
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

// `upsertThirdPartyCustomValue` moved to:
// src/routes/routes/Teacher/modules/TeacherModule.js

// `createGenericFolder`, `updateGenericFolder`, and `deleteGenericFolder` moved to:
// src/routes/routes/Teacher/routes/Courses/routes/Course/routes/Journal/routes/ManageFolders/modules/ManageFoldersThunks.js

export const getTotalCommentOfNode = ({ id, type }) => {
  return async (dispatch, getState) => {
    const isCommunity = getState().login.activeTab == "community";
    await client.query({
      query: getTotalCommentOfNodeQuery,
      variables: {
        id,
        type,
        isCommunity,
      },
      fetchPolicy: "network-only",
    });
  };
};

export const getWebLinkDetails = url => {
  return async (dispatch, getState) => {
    let result = null;
    try {
      await client.mutate({
        mutation: scrapeUrlMutation,
        variables: {
          url: url,
        },
        update: (
          cache,
          {
            data: {
              platform: { scrapeUrl },
            },
          }
        ) => {
          if (scrapeUrl != null) {
            // if yt video link is not scraped properly, then use the original link
            const updatedUrl = _.isEqual(
              scrapeUrl.url,
              "https://www.youtube.com/undefined"
            )
              ? url
              : scrapeUrl.url;
            const updateObject = {
              attachments: [
                {
                  type: "LINK",
                  name: scrapeUrl.title,
                  description: scrapeUrl.description,
                  url: updatedUrl,
                  mimeType: null,
                  thumbUrl: scrapeUrl.image
                    ? scrapeUrl.image
                    : DEFAULT_LINK_THUMB_URL,
                },
              ],
            };
            result = updateObject;
          } else {
            dispatch(
              setToastMsg({
                msg: "toastMsgs:web_link_not_valid",
                type: "warning",
                position: "toast-top-center",
              })
            );
          }
        },
      });

      return result;
    } catch (error) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-top-center",
        })
      );
      return result;
    }
  };
};

export const downloadFromUrl = ({
  downloadUrl,
  fileUploadId,
  onLoaded,
  onContentLoadFailed,
  headers,
  size,
  name,
  startProgress = 1,
  parentType,
  parentId,
  attachment,
  mimeType,
  shouldAskForSave = false,
  showErrorMessage = true,
  showProgress = true,
}) => {
  return async (dispatch, getState) => {
    if (!fileUploadId) {
      fileUploadId = _.get(attachment, "id", generateRandomId());
    }

    showProgress &&
      dispatch(
        setProgress({
          id: fileUploadId,
          progress: 0,
          attachment: attachment,
          parentType,
          parentId,
          status: "DOWNLOAD",
          cancelToken: () => {
            shouldAskForSave &&
              dispatch(removeProgressElement({ id: fileUploadId }));
          },
        })
      );
    if (!name) {
      name = _.get(attachment, "name", "") || "";
      name = htmlToText(name);
    }

    const { type, title, url } = attachment || {};

    const isBlobUrl = _.includes(url, "blob");

    if (isBlobUrl) {
      const { data: fileBlob } = await axios.get(url, {
        responseType: "blob",
      });

      if (shouldAskForSave) {
        saveAs(fileBlob, name);
      }

      return;
    }

    if (
      type === "NOTE" ||
      type === "RESPONSE" ||
      type === "LINK" ||
      type === "WORKBOOK"
    ) {
      showProgress &&
        dispatch(
          setProgress({
            id: fileUploadId,
            progress: startProgress,
          })
        );
      let fileExtension, fileBlob;
      if (type === "NOTE" || type === "RESPONSE") {
        fileExtension = "txt";

        if (!name && title) {
          const trimmedTitle = title.split(" ").join("");
          name = trimmedTitle.substring(0, 8);
        }
        fileBlob = new Blob([title], {
          type: "text/plain",
        });
      } else {
        const attachmentUrl =
          type === "WORKBOOK"
            ? _.get(attachment, "metadata.publicUrl", "")
            : url;
        fileExtension = "html";
        fileBlob = new Blob(
          [
            `<html>
        <head>
            <meta http-equiv="Refresh" content="0;url=${attachmentUrl}" />
        </head>
        </html>`,
          ],
          {
            type: "text/html",
          }
        );
      }

      if (onLoaded) {
        onLoaded(fileBlob);
      } else {
        dispatch(removeProgressElement({ id: fileUploadId }));
      }

      if (shouldAskForSave) {
        if (_.isEmpty(name)) {
          name = "toddle_" + moment().format("DD-MM-YY_h_mm");
        }
        name = `${name}.${fileExtension}`;
        saveAs(fileBlob, name);
      }
    } else {
      if (!size) {
        size = _.get(attachment, "metadata.size", 0);
      }
      if (!mimeType) {
        mimeType = _.get(attachment, "mimeType", "");
      }
      if (!downloadUrl) {
        downloadUrl = _.get(attachment, "url", "");
      }
      // const tempUrl = _.replace(downloadUrl, getCloudUrl(), "");

      let extension = "";
      // if (tempUrl.includes(".")) {
      //   extension = _.last(_.split(tempUrl, "."));
      // }

      try {
        const URLObject = new URL(downloadUrl);
        const filename = URLObject.pathname.split("/").pop();
        const splitFilename = _.split(filename, ".");
        if (splitFilename.length > 1) {
          extension = splitFilename.pop();
        }
      } catch (error) {}

      if (!extension && mimeType !== "application/octet-stream") {
        const mimeObj = _.get(MimeDb, mimeType, {});
        if (mimeObj.extensions) {
          extension = mimeObj.extensions[0];
        } else if (mimeType) {
          mimeType.split("/")[1];
        }
      }

      //Append extension in name to resolve windows issue
      //Check wheather there is already an extension in name
      if (!!extension && _.last(_.split(name, ".")) != extension) {
        name = `${name}.${extension}`;
      }
      //console.log("download name:", name);

      // If mimeType was application/octet-stream
      // then check whether we have fileExtension in url or not
      // if not then don't put any file extension
      // if (mimeType === "application/octet-stream" && !tempUrl.includes(".")) {
      //   name = _.first(_.split(name, "."));
      // }

      // if (!new RegExp(/\?.+=.*/g).test(downloadUrl)) {
      //   downloadUrl = `${downloadUrl}?_=${new Date().getTime()}`;
      // } else {
      //   downloadUrl = `${downloadUrl}&_=${new Date().getTime()}`;
      // }

      var xhr = new XMLHttpRequest();
      xhr.withCredentials = allowURLWithCredentials(downloadUrl);
      // Handled the cors issue with cors-anywhere link while downloading a file
      xhr.open("GET", `${downloadUrl}`, true);

      // Set headers
      _.forEach(headers, header => {
        xhr.setRequestHeader(header.label, header.value);
      });

      xhr.responseType = "blob";

      if (size) {
        const total = size;
        xhr.onprogress = event => {
          showProgress &&
            dispatch(
              setProgress({
                id: fileUploadId,
                progress: ((event.loaded / total) * startProgress).toFixed(0),
              })
            );
        };
      } else {
        showProgress &&
          dispatch(
            setProgress({
              id: fileUploadId,
              progress: startProgress,
            })
          );
      }

      xhr.onload = () => {
        const fileBlob = xhr.response;
        fileBlob["name"] = name;

        if (xhr.status == 200) {
          if (onLoaded) {
            onLoaded(fileBlob);
          } else {
            dispatch(removeProgressElement({ id: fileUploadId }));
          }
          if (shouldAskForSave) {
            saveAs(fileBlob, name);
          }
        } else {
          dispatch(removeProgressElement({ id: fileUploadId }));
          if (showErrorMessage) {
            dispatch(setToastMsg("toastMsgs:unable_to_download"));
          }
          if (onContentLoadFailed) {
            onContentLoadFailed({ errorMessage: `xhr status is not 200` });
          }
        }
      };

      xhr.onerror = e => {
        //console.log("error", e);
        if (onContentLoadFailed) {
          onContentLoadFailed({ errorMessage: `Failed to load xhr` });
        }
        if (showErrorMessage) {
          dispatch(setToastMsg("toastMsgs:unable_to_download"));
        }
        dispatch(removeProgressElement({ id: fileUploadId }));
      };

      xhr.send();
      showProgress &&
        dispatch(
          setProgress({
            id: fileUploadId,
            cancelToken: () => {
              xhr.abort();
              if (xhr.status == 0) {
                if (onContentLoadFailed) {
                  onContentLoadFailed({
                    isCancelled: true,
                    errorMessage: `Cancelled Download`,
                  });
                }
                dispatch(setToastMsg("toastMsgs:download_cancelled"));
                dispatch(removeProgressElement({ id: fileUploadId }));
              }
            },
          })
        );
    }
  };
};

export const downloadAttachmentZip = ({
  attachmentsObjects,
  isEvidence = false,
  zipFileName = "",
  showAttachmentName = false,
  enableUniqueNaming = false, // when showAttachmentName is true then attachment having same name will have suffix _1, _2 etc
}) => {
  return (dispatch, getState) => {
    const lengthOfAttachmentsObjects = _.size(attachmentsObjects);
    const zip = new JSZip();
    if (lengthOfAttachmentsObjects > 1) {
      const foldersObj = {};
      let folderCount = lengthOfAttachmentsObjects;
      dispatch(
        setProgress({
          id: zipFileName
            ? zipFileName
            : isEvidence
            ? "allEvidences"
            : "allSubmissions",
          attachment: { name: isEvidence ? "evidences" : "submissions" },
          status: "DOWNLOAD",
        })
      );
      _.map(attachmentsObjects, ({ folderName, attachments }, folderId) => {
        if (!_.isEmpty(attachments)) {
          foldersObj[folderId] = zip.folder(`${folderName}_${folderId}`);
        } else {
          folderCount--;
        }
        let attachmentCount = _.get(attachments, "length", 0);

        // Track duplicate names
        const nameCountMap = {};
        const nameIndexMap = {};
        if (showAttachmentName && enableUniqueNaming) {
          _.forEach(attachments, attachment => {
            const name = _.get(attachment, "name", "sample");
            nameCountMap[name] = (nameCountMap[name] || 0) + 1;
            nameIndexMap[name] = 0;
          });
        }

        _.map(attachments, attachment => {
          if (
            attachment.type === "NOTE" ||
            attachment.type === "RESPONSE" ||
            attachment.type === "LINK" ||
            attachment.type === "WORKBOOK"
          ) {
            let fileExtension, fileBlob;
            if (attachment.type === "NOTE" || attachment.type === "RESPONSE") {
              fileExtension = "txt";
              fileBlob = attachment.title;
            } else {
              const attachmentUrl =
                attachment.type === "WORKBOOK"
                  ? _.get(attachment, "metadata.publicUrl", "")
                  : attachment.url;
              fileExtension = "html";
              fileBlob = `<html>
                  <head>
                      <meta http-equiv="Refresh" content="0;url=${attachmentUrl}" />
                  </head>
                  </html>`;
            }
            let fileName;
            if (showAttachmentName) {
              const baseName = _.get(attachment, "name", "sample");
              if (enableUniqueNaming && nameCountMap[baseName] > 1) {
                nameIndexMap[baseName]++;
                fileName = `${baseName}_${nameIndexMap[baseName]}`;
              } else {
                fileName = baseName;
              }
            } else {
              fileName = `${folderName}_${
                attachments.length - attachmentCount + 1
              }`;
            }
            if (attachment.type === "RESPONSE") fileName = "response";

            foldersObj[folderId].file(`${fileName}.${fileExtension}`, fileBlob);
            attachmentCount--;
            if (attachmentCount == 0) folderCount--;
            if (folderCount == 0) {
              zip.generateAsync({ type: "blob" }).then(function (content) {
                saveAs(
                  content,
                  zipFileName
                    ? zipFileName
                    : isEvidence
                    ? `Evidences.zip`
                    : "submissions.zip"
                );
              });
              dispatch(
                removeProgressElement({
                  id: zipFileName
                    ? zipFileName
                    : isEvidence
                    ? "allEvidences"
                    : "allSubmissions",
                })
              );
            }
          } else {
            dispatch(
              downloadFromUrl({
                attachment,
                showProgress: false,
                onLoaded: fileBlob => {
                  const fileBlobMimeType = fileBlob.type;
                  let fileExtension = getFileExtensionFromMimeType({
                    mimeType: fileBlobMimeType,
                  });

                  let attachmentFileExtension = _.get(
                    attachment,
                    "metadata.fileExtension",
                    ""
                  );

                  if (_.isEmpty(attachmentFileExtension)) {
                    attachmentFileExtension =
                      getFileExtensionFromFilename({
                        fileName: _.get(attachment, "name", ""),
                      }) || "";
                  }

                  // if the given fileBlobMimeType does not match any extension then mime-types library return false
                  // so fileExtension will be false, in this case file downloaded will be fileName.false
                  // to prevent this we will use fileExtension from attachment metadata if fileExtension = false
                  // https://github.com/jshttp/mime-types/blob/c77d6b02139075e4f63230a970411b3c92d066e2/index.js#L118
                  if (
                    (_.isEqual(fileBlobMimeType, "application/octet-stream") ||
                      !fileExtension) &&
                    !_.isEmpty(attachmentFileExtension)
                  ) {
                    fileExtension = attachmentFileExtension;
                  }

                  let fileName;
                  if (showAttachmentName) {
                    const baseName = _.get(attachment, "name", "sample");
                    if (enableUniqueNaming && nameCountMap[baseName] > 1) {
                      nameIndexMap[baseName]++;
                      fileName = `${baseName}_${nameIndexMap[baseName]}.${fileExtension}`;
                    } else {
                      fileName = `${baseName}.${fileExtension}`;
                    }
                  } else {
                    fileName = `${folderName}_${
                      attachments.length - attachmentCount + 1
                    }.${fileExtension}`;
                  }

                  foldersObj[folderId].file(fileName, fileBlob);
                  attachmentCount--;
                  if (attachmentCount == 0) folderCount--;
                  if (folderCount == 0) {
                    zip
                      .generateAsync({ type: "blob" })
                      .then(function (content) {
                        saveAs(
                          content,
                          zipFileName
                            ? zipFileName
                            : isEvidence
                            ? `Evidences.zip`
                            : "submissions.zip"
                        );
                      });
                    dispatch(
                      removeProgressElement({
                        id: zipFileName
                          ? zipFileName
                          : isEvidence
                          ? "allEvidences"
                          : "allSubmissions",
                      })
                    );
                  }
                },
                onContentLoadFailed: async ({ isCancelled }) => {},
              })
            );
          }
        });
      });
    } else {
      const attachmentsObjData = _.first(
        _.map(attachmentsObjects, (attachmentObj, folderId) => {
          attachmentObj["folderId"] = folderId;
          return attachmentObj;
        })
      );
      const attachments = _.get(attachmentsObjData, "attachments", []);
      const folderName = _.get(attachmentsObjData, "folderName", "");
      const folderId = _.get(attachmentsObjData, "folderId", "");

      let attachmentCount = _.get(attachments, "length", 0);

      // Track duplicate names
      const nameCountMap = {};
      const nameIndexMap = {};
      if (showAttachmentName && enableUniqueNaming) {
        _.forEach(attachments, attachment => {
          const name = _.get(attachment, "name", "sample");
          nameCountMap[name] = (nameCountMap[name] || 0) + 1;
          nameIndexMap[name] = 0;
        });
      }

      dispatch(
        setProgress({
          id: zipFileName
            ? zipFileName
            : `${folderName}_${folderId}'s_${
                isEvidence ? "evidence" : "submission"
              }`,
          attachment: {
            name: zipFileName
              ? zipFileName
              : `${folderName}_${folderId}'s_${
                  isEvidence ? "evidence" : "submission"
                }`,
          },
          status: "DOWNLOAD",
        })
      );
      _.map(attachments, attachment => {
        if (
          attachment.type === "NOTE" ||
          attachment.type === "RESPONSE" ||
          attachment.type === "LINK" ||
          attachment.type === "WORKBOOK"
        ) {
          let fileExtension, fileBlob;
          if (attachment.type === "NOTE" || attachment.type === "RESPONSE") {
            fileExtension = "txt";
            fileBlob = attachment.title;
          } else {
            const attachmentUrl =
              attachment.type === "WORKBOOK"
                ? _.get(attachment, "metadata.publicUrl", "")
                : attachment.url;
            fileExtension = "html";
            fileBlob = `<html>
                  <head>
                      <meta http-equiv="Refresh" content="0;url=${attachmentUrl}" />
                  </head>
                  </html>`;
          }
          let fileName;
          if (showAttachmentName) {
            const baseName = _.get(attachment, "name", "sample");
            if (enableUniqueNaming && nameCountMap[baseName] > 1) {
              nameIndexMap[baseName]++;
              fileName = `${baseName}_${nameIndexMap[baseName]}`;
            } else {
              fileName = baseName;
            }
          } else {
            fileName = `${folderName}_${
              attachments.length - attachmentCount + 1
            }`;
          }
          if (attachment.type === "RESPONSE") fileName = "response";

          zip.file(`${fileName}.${fileExtension}`, fileBlob);
          attachmentCount--;
          if (attachmentCount == 0) {
            zip.generateAsync({ type: "blob" }).then(function (content) {
              saveAs(
                content,
                zipFileName
                  ? zipFileName
                  : isEvidence
                  ? `${folderName}_evidence.zip`
                  : `${folderName}_${folderId}'s_submission.zip`
              );
            });
            dispatch(
              removeProgressElement({
                id: zipFileName
                  ? zipFileName
                  : `${folderName}_${folderId}'s_${
                      isEvidence ? "evidence" : "submission"
                    }`,
              })
            );
          }
        } else {
          dispatch(
            downloadFromUrl({
              attachment,
              showProgress: false,
              onLoaded: fileBlob => {
                const fileBlobMimeType = fileBlob.type;
                let fileExtension = getFileExtensionFromMimeType({
                  mimeType: fileBlobMimeType,
                });

                let attachmentFileExtension = _.get(
                  attachment,
                  "metadata.fileExtension",
                  ""
                );

                if (_.isEmpty(attachmentFileExtension)) {
                  attachmentFileExtension =
                    getFileExtensionFromFilename({
                      fileName: _.get(attachment, "name", ""),
                    }) || "";
                }

                // if the given fileBlobMimeType does not match any extension then mime-types library return false
                // so fileExtension will be false, in this case file downloaded will be fileName.false
                // to prevent this we will use fileExtension from attachment metadata if fileExtension = false
                // https://github.com/jshttp/mime-types/blob/c77d6b02139075e4f63230a970411b3c92d066e2/index.js#L118
                if (
                  (_.isEqual(fileBlobMimeType, "application/octet-stream") ||
                    !fileExtension) &&
                  !_.isEmpty(attachmentFileExtension)
                ) {
                  fileExtension = attachmentFileExtension;
                }

                let fileName;
                if (showAttachmentName) {
                  const baseName = _.get(attachment, "name", "sample");
                  if (enableUniqueNaming && nameCountMap[baseName] > 1) {
                    nameIndexMap[baseName]++;
                    fileName = `${baseName}_${nameIndexMap[baseName]}.${fileExtension}`;
                  } else {
                    fileName = `${baseName}.${fileExtension}`;
                  }
                } else {
                  fileName = `${folderName}_${
                    attachments.length - attachmentCount + 1
                  }.${fileExtension}`;
                }

                zip.file(fileName, fileBlob);
                attachmentCount--;
                if (attachmentCount == 0) {
                  zip.generateAsync({ type: "blob" }).then(function (content) {
                    saveAs(
                      content,
                      zipFileName
                        ? zipFileName
                        : isEvidence
                        ? `${folderName}_evidence.zip`
                        : `${folderName}_${folderId}'s_submission.zip`
                    );
                  });
                  dispatch(
                    removeProgressElement({
                      id: zipFileName
                        ? zipFileName
                        : `${folderName}_${folderId}'s_${
                            isEvidence ? "evidence" : "submission"
                          }`,
                    })
                  );
                }
              },
              onContentLoadFailed: async ({ isCancelled }) => {},
            })
          );
        }
      });
    }
  };
};

export const exceededSizeError = ({ fileTypesAndMaxSizes } = {}) => {
  return (dispatch, getState) => {
    dispatch(
      setToastMsg({
        ...getExceededSizeToastMsgAndLocaleParams({ fileTypesAndMaxSizes }),
        type: "warning",
        position: "toast-top-center",
      })
    );
  };
};

export const unsupportedFileExtensionError = ({
  notAllowedFileCount = 0,
  notAllowedFileExtensions,
}) => {
  return dispatch => {
    const fileFormats = notAllowedFileExtensions;
    const fileFormatCount = _.size(fileFormats);

    dispatch(
      setToastMsg({
        msg:
          "toastMsgs:fileCount_file_will_be_not_uploaded_fileFormat_not_allowed",
        locale_params: [
          {
            key: "fileCount",
            value: notAllowedFileCount,
            isPlainText: true,
          },
          {
            key: "fileFormatCount",
            value: fileFormatCount,
            isPlainText: true,
          },
          {
            key: "entity1",
            value: `"${_.join(_.slice(fileFormats, 0, -1), ", ")}"`,
            isPlainText: true,
          },
          {
            key: "entity2",
            value: `"${_.last(fileFormats)}"`,
            isPlainText: true,
          },
        ],
        type: "warning",
        timeOut: 3500,
        position: "toast-top-center",
      })
    );
  };
};

export const getCriteriaSetOfPypType = ({
  type,
  parentId = null,
  grades = null,
  levelId = null,
  subType = null,
  criteriaType = null,
  preserveCriteriaSetOrder = false,
}) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const orgId = userInfo.org_id;
    const ratingLevels = _.get(
      getOrganizationConstantsFromCache(orgId),
      "ratingLevels",
      []
    );

    const academicCriteriaSets = _.get(
      getOrganizationConstantsFromCache(orgId),
      "academicCriteriaSets",
      []
    );

    let filteredRatings = _.filter(ratingLevels, rating => {
      return _.isArray(type)
        ? _.includes(type, rating.ibPYPElementType)
        : rating.ibPYPElementType == type;
    });

    if (parentId) {
      filteredRatings = _.filter(filteredRatings, rating => {
        return rating.ibPYPParentElementId == parentId;
      });
    }

    if (levelId) {
      filteredRatings = _.filter(filteredRatings, rating => {
        return rating.levelId == levelId;
      });
    }

    if (subType) {
      filteredRatings = _.filter(filteredRatings, rating => {
        return rating.subType == subType;
      });
    }

    let criteriaSets = _.map(
      _.reduce(
        filteredRatings,
        (result, rating) => {
          result = _.unionBy(result, rating.academicCriteriaSets, "id");
          return result;
        },
        []
      ),
      set => getCriteriaSetSlimDetailsFromCache(set.id)
    );

    criteriaSets = _.filter(criteriaSets, set => {
      return _.findIndex(academicCriteriaSets, { id: set.id }) >= 0;
    });

    // Sort the criteriaSets in the same order they appear in academicCriteriaSets
    if (preserveCriteriaSetOrder) {
      criteriaSets = _.sortBy(criteriaSets, set => {
        return _.findIndex(academicCriteriaSets, { id: set?.id });
      });
    }

    if (grades) {
      criteriaSets = _.filter(
        criteriaSets,
        set =>
          !_.isEmpty(
            _.intersectionWith(
              set.grades,
              grades,
              (setGrade, grade) => setGrade.id == grade
            )
          )
      );
    }

    if (criteriaType) {
      criteriaSets = _.filter(
        criteriaSets,
        set => set?.criteriaType == criteriaType
      );
    }

    return criteriaSets;
  };
};

export const checkCriteriaSetOfPypTypeInLevels = ({
  type,
  parentId = null,
  levelId,
  setId,
  checkLevelId,
}) => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const orgId = userInfo.org_id;
    const ratingLevels = _.get(
      getOrganizationConstantsFromCache(orgId),
      "ratingLevels",
      []
    );

    return checkCriteriaSetOfPypTypeInLevelsLocalMemoize({
      type,
      parentId,
      levelId,
      setId,
      ratingLevels,
      checkLevelId,
    });

    // const filteredRatings = _.filter(ratingLevels, level => {
    //   if (parentId) {
    //     return (
    //       level.ibPYPElementType == type &&
    //       level.ibPYPParentElementId == parentId &&
    //       level.levelId == levelId
    //     );
    //   } else {
    //     return level.ibPYPElementType == type && level.levelId == levelId;
    //   }
    // });

    // let criteriaSets = _.map(
    //   _.reduce(
    //     filteredRatings,
    //     (result, rating) => {
    //       result = _.unionBy(result, rating.academicCriteriaSets, "id");
    //       return result;
    //     },
    //     []
    //   ),
    //   set => getCriteriaSetDetailsFromCache(set.id)
    // );

    // return _.findIndex(criteriaSets, { id: setId }) >= 0;
  };
};

export const markCommentRead = ({
  nodeId,
  type,
  parentType,
  isCommunity,
  commentsKey,
  isCommentV2,
  updateReadCount, // Used to update the read count manually
  commentFilters,
}) => {
  return async (dispatch, getState) => {
    const unreadCountKey = isCommentV2 ? "unreadCountV2" : "unreadCount";
    const userInfo = getUserInfo();

    if (!getState().login.userLoggedIn) {
      return;
    }
    const nodeDetails = getCommentsOfNodeFromCache({
      nodeId,
      type,
      isCommunity,
      commentFilters,
    });

    if (_.isFunction(updateReadCount))
      updateReadCount({
        readCommentCount: _.get(nodeDetails, [commentsKey, unreadCountKey], 0),
        nodeId,
      });

    const updatedNodeDetails = update(nodeDetails, {
      [commentsKey]: { [unreadCountKey]: { $set: 0 } },
    });
    writeCommentNodeFragment({
      nodeId,
      parentType,
      type,
      data: updatedNodeDetails,
      commentFilters,
      isCommunity,
    });

    const mutationVariables = isCommentV2
      ? {
          id: nodeId,
          entityType: parentType,
        }
      : {
          parentId: nodeId,
          parentType,
          userId: userInfo.id,
        };

    try {
      await client.mutate({
        mutation: isCommentV2
          ? updateEntityIsReadMutation
          : markCommentsReadForFieldMutation,
        variables: mutationVariables,
        update: (
          cache,
          {
            data: {
              platform: { markCommentsReadForParent },
            },
          }
        ) => {
          if (markCommentsReadForParent) {
            // writeCommentNodeFragment({
            //   nodeId,
            //   type,
            //   data: updatedNodeDetails
            // });
          }
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      // throw e;
    }
  };
};

export const updateBasicUserDetails = (input = {}, others = {}) => {
  return async (dispatch, getState) => {
    let userInfo = getUserInfo();
    if (input.portalType)
      userInfo = getUserInfo({ portalType: input.portalType });
    const userId = userInfo.id;
    const userEntityType = userInfo.userEntityType;
    const userDetails = getUserBasicDetailsFromCache({
      id: userId,
      type: userEntityType,
    });
    writeUserBasicDetailsFromCache({
      id: userId,
      type: userEntityType,
      data: { ...userDetails, ...input },
    });
    try {
      await client.mutate({
        mutation: updateBasicUserDetailsMutation,
        variables: {
          id: userId,
          ...input,
          ...others,
        },
      });
    } catch (e) {
      writeUserBasicDetailsFromCache({
        id: userId,
        type: userEntityType,
        data: userDetails,
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

// `createComment`, `updateComment`, and `deleteComment` were moved to
// `src/AppComponents/CommentBoxV2/modules/CommentThunks.js`.

// `resetUserCircularNewCount` was moved to
// `src/AppComponents/Circulars/modules/CircularsModule.js`.

export const createAttachment = ({
  nodeId,
  attachment,
  type,
  parentType,
  portalType,
  lockingState,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;

    try {
      const response = await client.mutate({
        mutation: createAttachmentMutation,
        variables: {
          name: attachment.name,
          title: attachment.title,
          url: attachment.url,
          type: attachment.type,
          thumbUrl: attachment.thumbUrl ? attachment.thumbUrl : "",
          mimeType: attachment.mimeType,
          createdBy: userId,
          parentId: nodeId,
          parentType: parentType,
          metadata: attachment.metadata,
          portalType,
          lockingState,
          toddleDoc: attachment.toddleDoc,
        },

        update: (
          cache,
          {
            data: {
              platform: { createAttachment },
            },
          }
        ) => {
          if (!isExcludedParentTypesForAttachmentCache({ parentType: type })) {
            const nodeDetails = getAttachmentOfNodeFromCache({ nodeId, type });
            const attachments = _.get(nodeDetails, "attachments", [])
              ? _.get(nodeDetails, "attachments", [])
              : [];

            const data = {
              ...nodeDetails,
              attachments: [...attachments, ...createAttachment],
            };

            writeAttachmentNodeFragment({
              nodeId,
              data,
              type,
            });
          }
        },
      });
      return _.get(response, "data.platform.createAttachment", []);
    } catch (e) {
      //console.log(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return [];
      // writeAssessmentFieldFragment({
      //   field_id,
      //   data: fieldDetails
      // });
    }
  };
};

export const createAttachmentGroups = ({
  input,
  portalType,
  groupParentId,
  groupParentType,
}) => {
  return async (dispatch, getState) => {
    try {
      const result = await client.mutate({
        mutation: createAttachmentGroupsMutation,
        variables: {
          input,
          portalType,
        },
        update: (
          cache,
          {
            data: {
              platform: { createAttachmentGroups },
            },
          }
        ) => {
          const {
            parentId: inputParentId,
            parentType: inputParentType,
          } = input;
          const parentId = groupParentId ? groupParentId : inputParentId;
          const parentType = groupParentType
            ? groupParentType
            : inputParentType;
          if (!isExcludedParentTypesForAttachmentCache({ parentType })) {
            const nodeDetails = getAttachmentGroupsOfNodeFromCache({
              id: parentId,
              type: parentType,
            });
            const attachmentGroups =
              _.get(nodeDetails, "attachmentGroups", []) || [];

            const data = {
              ...nodeDetails,
              attachmentGroups: [
                ...attachmentGroups,
                ...createAttachmentGroups,
              ],
            };

            writeAttachmentGroupsOfNodeInCache({
              id: parentId,
              data,
              type: parentType,
            });
          }
        },
      });

      return _.get(result, "data.platform.createAttachmentGroups", []);
    } catch (err) {
      //console.log(err);

      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return [];
    }
  };
};

export const createAttachmentGroupsV2 = ({ input, portalType }) => {
  return async (dispatch, getState) => {
    try {
      if (input.parentId) {
        const result = await client.mutate({
          mutation: createAttachmentGroupsMutationV2,
          variables: {
            input,
            portalType,
          },
          update: (
            cache,
            {
              data: {
                platform: { createAttachmentGroupsV2 },
              },
            }
          ) => {
            const { parentId, parentType } = input;
            if (!isExcludedParentTypesForAttachmentCache({ parentType })) {
              const nodeDetails = getAttachmentGroupsOfNodeFromCache({
                id: parentId,
                type: parentType,
              });
              const response = _.get(
                createAttachmentGroupsV2,
                "0.response",
                null
              );
              if (!response) {
                return;
              }
              const attachmentGroups =
                _.get(nodeDetails, "attachmentGroups", []) || [];
              const newAttachmentGroup = [response];
              const data = {
                ...nodeDetails,
                attachmentGroups: [...attachmentGroups, ...newAttachmentGroup],
              };
              writeAttachmentGroupsOfNodeInCache({
                id: parentId,
                data,
                type: parentType,
              });
            }
          },
        });
        const resArray = _.get(
          result,
          "data.platform.createAttachmentGroupsV2",
          []
        );
        //console.log(resArray);
        const response = _.get(resArray, ["0", "response"]);
        if (!response) {
          const errorCode = _.get(resArray, ["0", "warning", "errorCode"]);
          const errorText = _.get(ATTACHMENT_WARNINGS, errorCode, "");
          if (errorText) {
            dispatch(
              setToastMsg({
                msg: errorText,
              })
            );
            return [];
          }
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
          return [];
        }
        return [response];
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (err) {
      //console.log(err);

      return [];
    }
  };
};

export const deleteAttachmentGroups = ({
  attachmentGroupIds,
  parentId,
  parentType,
  portalType,
}) => {
  return async (dispatch, getState) => {
    try {
      const result = await client.mutate({
        mutation: deleteAttachmentGroupsMutation,
        variables: {
          attachmentGroupIds,
          portalType,
        },
        update: (
          cache,
          {
            data: {
              platform: { deleteAttachmentGroups },
            },
          }
        ) => {
          if (
            !isExcludedParentTypesForAttachmentCache({ parentType }) &&
            deleteAttachmentGroups
          ) {
            const nodeDetails = getAttachmentGroupsOfNodeFromCache({
              id: parentId,
              type: parentType,
            });

            const attachmentGroups =
              _.get(nodeDetails, "attachmentGroups", []) || [];

            const data = {
              ...nodeDetails,
              attachmentGroups: _.filter(
                attachmentGroups,
                ({ id }) => _.indexOf(attachmentGroupIds, id) < 0
              ),
            };

            writeAttachmentGroupsOfNodeInCache({
              id: parentId,
              data,
              type: parentType,
            });
          }
        },
      });

      return result;
    } catch (err) {
      //console.log(err);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const reorderAttachmentGroups = ({
  inputVariables,
  parentId,
  parentType,
  updatedValue,
}) => {
  return async dispatch => {
    try {
      const nodeDetails = getAttachmentGroupsOfNodeFromCache({
        id: parentId,
        type: parentType,
      });

      const data = {
        ...nodeDetails,
        attachmentGroups: updatedValue,
      };

      writeAttachmentGroupsOfNodeInCache({
        id: parentId,
        data,
        type: parentType,
      });

      await client.mutate({
        mutation: reorderAttachmentGroupMutation,
        variables: { input: inputVariables },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deleteAttachment = ({
  nodeId,
  attachmentId,
  type,
  portalType,
  refetchQueries = [],
}) => {
  return async (dispatch, getState) => {
    //console.log(nodeId, attachmentId, type);
    const nodeDetails = getAttachmentOfNodeFromCache({ nodeId, type });
    const attachments = _.get(nodeDetails, "attachments", []);

    const updatedAttachments = _.filter(attachments, attachment => {
      return attachment.id !== attachmentId;
    });

    if (!isExcludedParentTypesForAttachmentCache({ parentType: type })) {
      writeAttachmentNodeFragment({
        nodeId,
        data: { ...nodeDetails, attachments: updatedAttachments },
        type,
      });
    }

    try {
      await client.mutate({
        mutation: deleteAttachmentMutation,
        variables: {
          attachmentIds: [attachmentId],
          portalType,
        },
        refetchQueries,
        awaitRefetchQueries: !_.isEmpty(refetchQueries),
      });
    } catch (e) {
      if (!isExcludedParentTypesForAttachmentCache({ parentType: type })) {
        writeAttachmentNodeFragment({
          nodeId,
          data: nodeDetails,
          type,
        });
      }
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const convertPDFToWorkbook = ({ url }) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: convertPdfToWorkbookMutation,
        variables: {
          url,
        },
      });
      const dataObj = _.get(response, "data.platform.convertPdfToWorkbook", {});
      const { isSuccess = true, response: responseObj, warning } = dataObj;

      if (isSuccess) {
        if (warning && _.isObject(warning)) {
          const localKey = _.get(warning, "key", "");
          if (localKey) {
            if (localKey === "wrbk_max_number_of_pages_reached") {
              const maxNoOfPages = _.get(warning, "maxNoOfPages", 15);
              dispatch(
                setToastMsg({
                  msg: "toastMsgs:wrbk_max_number_of_pages_reached",
                  locale_params: [
                    {
                      key: "count",
                      value: maxNoOfPages,
                      isPlainText: true,
                    },
                  ],
                  type: "warning",
                })
              );
              responseObj.isPdfTruncated = true;
            } else {
              dispatch(setToastMsg(`toastMsgs:${localKey}`));
            }
          }
        }
      } else if (isSuccess === false || _.isEmpty(responseObj)) {
        //add breadcrumbs for graphql errors
        if (warning) {
          Sentry.addBreadcrumb({
            category: "console",
            level: "info",
            message: warning,
          });
        }
        throw Error("convertPDFToWorkbook - failed ");
      }

      return responseObj;
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      throw e;
    }
  };
};

// `updateFieldMutationFunc`, `updateField`, and their private helpers
// (`dispatchUpdateFieldMutationFunc`, `debouncedDispatchUpdateFieldMutation`)
// were moved to `src/modules/FieldUpdateThunks.js`.

/**
 * This function redirects you to specified path from the current one
 *
 * Possible 'route' examples:
 * - /path/to/route
 * - ?key1=value1&key2=value2
 * - /path/to/route?key1=value1&key2=value2
 *
 * @param {*} param0
 * @param {string} route: A destination route string (pathname?queryParams)
 * @param {type} type: Router action type push or replace
 * @param {object} location: A location descriptor
 * @param {string} replacePath: A string sub-route to replace from existing route
 */
export const goToRelativeRoute = ({
  route,
  type = "push",
  location = null,
  replacePath = null,
  queryParamsToPreserve,
  state = {},
}) => {
  return dispatch => {
    let tempLocation = {};

    if (location) {
      const combinedSearch = getCombinedLocationSearch({
        destinationSearch: location.search,
        queryParamsToPreserve,
      });

      tempLocation = { ...location, search: combinedSearch };
    } else {
      const [pathname, queryParamsString] = _.split(route, "?");

      const combinedSearch = getCombinedLocationSearch({
        destinationSearch: queryParamsString,
        queryParamsToPreserve,
      });

      tempLocation = { pathname: pathname, search: combinedSearch };
    }

    const relativePath = getRelativePath(
      `${tempLocation.pathname}`,
      replacePath
    );

    if (type == "push") {
      const isCommandClickEnabled = ACLStore.can(
        "FeatureFlag:EnableCommandClick"
      );
      const newWindowUrl =
        window.location.origin + relativePath + tempLocation.search;

      if (window.shouldOpenInNewTab && _.isEqual(isCommandClickEnabled, true)) {
        dispatch(
          openLinkInNewTab({
            url: newWindowUrl,
          })
        );
      } else {
        push({
          state,
          ...tempLocation,
          pathname: relativePath,
        });
      }
    } else {
      replace({
        state,
        ...tempLocation,
        pathname: relativePath,
      });
    }
  };
};

// `getPrintFile`, `printFamilyInviteInBulk`, and `generatePdfZipInBulk` moved to:
// src/modules/PrintThunks.js

/**
 * This thunk helps to open a provided path/link in new tab
 *
 * @param {object} param0
 * @param {string} param0.url: absolute path of the page
 * @param {string} param0.openInNewThread: if true, open in new browser thread instead of
 *                 using existing one.
 *
 * @returns null
 */
export const openLinkInNewTab = ({ url, openInNewThread = true }) => {
  return async dispatch => {
    let winRef = null;

    try {
      if (openInNewThread) {
        // eslint-disable-next-line no-restricted-properties
        winRef = window.open(url, "_blank", "noopener");
      } else {
        // eslint-disable-next-line no-restricted-properties
        winRef = window.open("", "_blank");
        const loadingHTML = `<html style="height:100%"><body style="height:100%">
      <div style="height:100%;display:flex;flex:1;align-item:center;justify-content:center">
      <img style="width:40px" src="https://cloud.toddleapp.com/assets/webapp/loading.svg"/>
      </div></body></html>`;
        winRef.document.write(loadingHTML);

        if (url) {
          winRef.location = url;
        } else {
          dispatch(
            setToastMsg({
              msg: "toastMsgs:something_went_wrong",
              type: "warning",
              position: "toast-top-center",
            })
          );
        }
      }
    } catch (e) {
      if (winRef && winRef.close) winRef.close();
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-top-center",
        })
      );
    }
  };
};

// `removeFiles` moved to:
// src/AppComponents/OrganizationResources/modules/OrganizationResourcesModule/OrganizationResourcesThunks.js

export const updateResourceAttachments = resources => {
  return async (dispatch, getState) => {
    let result = {};
    try {
      result = await client.mutate({
        mutation: updateAttachmentAndBulkActivateResourcesMutation,
        variables: {
          input: resources,
        },
      });
      return result.data.platform.updateAttachmentAndBulkActivateResources;
    } catch (error) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-top-center",
        })
      );
      return result;
    }
  };
};

export const validateResourceLabels = ({
  parentId,
  type,
  isRootDirectory,
  resources,
  visibleTo,
}) => {
  return async (dispatch, getState) => {
    let result = {};
    try {
      result = await client.mutate({
        mutation: generateResourceLabelForExistingResourcesMutation,
        variables: {
          input: {
            parentId,
            type,
            isRootDirectory,
            resources,
            visibleTo,
          },
        },
      });
      return result.data.platform.generateResourceLabelForExistingResources;
    } catch (error) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-top-center",
        })
      );
      return result;
    }
  };
};

export const uploadFilesV3 = ({
  parentType,
  parentId,
  attachment: filesWithResourceMapId,
  portalType,
  isAuthenticated = true,
  startProgress,
  status,
  hideToastProgress = false,
  fileMapping,
}) => {
  return async (dispatch, getState) => {
    const startProgressValue = startProgress ? startProgress : 0;

    _.map(filesWithResourceMapId, file => {
      const progressObject = {
        id: file.resourceMapId,
        progress: startProgressValue,
        attachment: file,
        parentType,
        // to not show list of files in educator center
        parentId: -1,
        status: status ? status : "UPLOAD",
        startTime: new Date(),
        hideToastProgress,
      };

      dispatch(setProgress(progressObject));
    });

    const cancelledFiles = [];

    try {
      let result = null;
      const uploadStartTime = Date.now();
      const isVirusTaggingEnabled = getIsVirusTaggingEnabled();
      if (isAuthenticated) {
        const variables = getMutationVariable({
          files: filesWithResourceMapId,
          isVirusTaggingEnabled,
          portalType,
        });

        result = await client.mutate({
          mutation: bulkSignS3URLMutation,
          variables: {
            input: variables,
          },
        });
      } else {
        // TODO: handle for cases when isAuthenticated is false
      }
      const timeTakenToGetSignedURL = Date.now() - uploadStartTime;

      const progressOfUploads = _.get(
        getState(),
        "app_services.progressOfUploads",
        {}
      );
      const signS3URLs = isAuthenticated
        ? _.get(result, "data.platform.bulkSignS3URLV2", {})
        : _.get(result, "data", {});
      const allPromises = _.map(signS3URLs, async signS3URL => {
        const fileUploadTime = Date.now();
        const returnUrl = signS3URL.displayURL;
        const signedUrl = signS3URL.uploadURL;
        const tag = signS3URL.tag;
        const resourceMapId = signS3URL.id;
        const currentFile = _.find(
          filesWithResourceMapId,
          file => file.resourceMapId === resourceMapId
        );

        try {
          if (progressOfUploads[resourceMapId]) {
            const headersObj = {
              "Content-Type": currentFile.mimeType
                ? currentFile.mimeType
                : "application/octet-stream",
              "x-amz-tagging": tag,
            };

            if (signS3URL.enforceIfNoneMatch) {
              headersObj["If-None-Match"] = "*";
            }

            var options = {
              onUploadProgress: e => {
                const progressObject = {
                  id: resourceMapId,
                  progress:
                    startProgressValue +
                    (e.loaded / e.total) * (100.0 - startProgressValue),
                };

                dispatch(setProgress(progressObject));
              },
              headers: headersObj,
              cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                dispatch(setProgress({ id: resourceMapId, cancelToken: c }));
              }),
            };

            await axios.put(signedUrl, fileMapping[resourceMapId], options);
          }
          dispatch(removeProgressElement({ id: resourceMapId }));
          return {
            url: returnUrl,
            resourceMapId,
            uploadTime: Date.now() - fileUploadTime + timeTakenToGetSignedURL,
          };
        } catch (e) {
          dispatch(removeProgressElement({ id: resourceMapId }));
          cancelledFiles.push(currentFile.fileId);

          dispatch(setToastMsg("toastMsgs:unable_to_upload"));
          throw e;
        }
      });

      const uploadedFileUrls = _.filter(
        await Promise.all(allPromises),
        urlObj => urlObj
      );

      return { signedUrls: uploadedFileUrls, cancelledFiles };
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:unable_to_upload"));
      throw e;
    }
  };
};

export const uploadFileV2 = ({
  file,
  uploadId,
  startProgress,
  attachment,
  parentType,
  parentId,
  isAuthenticated = true,
  portalType,
  status,
  hideToastProgress = false,
  expiry,
  inputFileKey,
  shouldReturnSignedUrl = false,
}) => {
  return async (dispatch, getState) => {
    const fileUploadId = uploadId;
    const startProgressValue = startProgress ? startProgress : 0;
    const progressObject = {
      id: fileUploadId,
      progress: startProgressValue,
      attachment: attachment,
      parentType,
      parentId,
      status: status ? status : "UPLOAD",
      startTime: new Date(),
      hideToastProgress,
    };
    // case 1: when mimeType is empty, null, undefined , then we send application/octet-stream
    // case 2: when mimeType and fileExtention both are null/undefined empty
    // attachment.mimeType = "application/octet-stream";
    // attachment.metadata.fileExtension = "";
    dispatch(setProgress(progressObject));
    try {
      let result = null;

      const isVirusTaggingEnabled = getIsVirusTaggingEnabled();
      if (isAuthenticated) {
        const fileName = _.defaultTo(
          _.get(attachment, "name"),
          _.dropRight(_.get(file, "name", "").split(".")).join("."),
          ""
        );

        result = await client.mutate({
          mutation: signS3URLMutation,
          variables: {
            fileName: fileName,
            fileMimeType: attachment.mimeType
              ? attachment.mimeType
              : "application/octet-stream",
            fileGroup: attachment?.metadata?.fileGroup ?? "content",
            fileExtension: _.get(attachment, ["metadata", "fileExtension"], ""),
            portalType,
            doVirusScanning: isVirusTaggingEnabled,
            expiry,
            inputFileKey,
          },
        });
      } else {
        result = await axios.post(
          getBackendServerUrl({
            path: PATH_TO_GET_SIGNED_URL,
          }),
          {
            params: {
              fileMimeType: attachment.mimeType,
            },
          }
        );
      }

      const progressOfUploads = _.get(
        getState(),
        "app_services.progressOfUploads",
        {}
      );
      const signS3URL = isAuthenticated
        ? _.get(result, "data.platform.signS3URLV2", {})
        : _.get(result, "data", {});

      const returnUrl = shouldReturnSignedUrl
        ? signS3URL.signedDisplayURL
        : signS3URL.displayURL;
      const signedUrl = signS3URL.uploadURL;
      const tag = signS3URL.tag;

      if (progressOfUploads[fileUploadId]) {
        const headersObj = {
          "Content-Type": attachment.mimeType
            ? attachment.mimeType
            : "application/octet-stream",
          "x-amz-tagging": tag,
        };

        if (signS3URL.enforceIfNoneMatch) {
          headersObj["If-None-Match"] = "*";
        }

        var options = {
          onUploadProgress: e => {
            const progressObject = {
              id: fileUploadId,
              progress:
                startProgressValue +
                (e.loaded / e.total) * (100.0 - startProgressValue),
            };

            dispatch(setProgress(progressObject));
          },
          headers: headersObj,
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            dispatch(setProgress({ id: fileUploadId, cancelToken: c }));
          }),
        };

        await axios.put(signedUrl, file, options);
      }
      dispatch(removeProgressElement({ id: fileUploadId }));
      return returnUrl;
    } catch (e) {
      dispatch(removeProgressElement({ id: fileUploadId }));
      dispatch(setToastMsg("toastMsgs:unable_to_upload"));
      throw e;
    }
  };
};

export const uploadFile = ({
  file,
  uploadId,
  startProgress,
  attachment,
  parentType,
  parentId,
  isAuthenticated = true,
  portalType,
  showProgress = true,
  shouldReturnSignedUrl = false,
}) => {
  return (dispatch, getState) => {
    const fileUploadId = uploadId ? uploadId : generateRandomId();

    const startProgressValue = startProgress ? startProgress : 0;
    const progressObject = {
      id: fileUploadId,
      progress: startProgressValue,
      attachment: attachment,
      parentType,
      parentId,
      status: "UPLOAD",
      startTime: new Date(),
    };

    if (showProgress) dispatch(setProgress(progressObject));

    const prom = new Promise((resolve, reject) => {
      let returnUrl = null;
      let requestObj = null;

      const isVirusTaggingEnabled = getIsVirusTaggingEnabled();
      if (isAuthenticated) {
        requestObj = client.mutate({
          mutation: signS3URLMutation,
          variables: {
            fileMimeType: attachment.mimeType
              ? attachment.mimeType
              : "application/octet-stream",
            fileGroup: "content",
            portalType,
            doVirusScanning: isVirusTaggingEnabled,
          },
        });
      } else {
        requestObj = axios.post(
          getBackendServerUrl({
            path: PATH_TO_GET_SIGNED_URL,
          }),
          {
            params: {
              fileMimeType: attachment.mimeType,
            },
          }
        );
      }

      requestObj
        .then(result => {
          const progressOfUploads = _.get(
            getState(),
            "app_services.progressOfUploads",
            {}
          );
          const signS3URL = isAuthenticated
            ? _.get(result, "data.platform.signS3URLV2", {})
            : _.get(result, "data", {});
          const tag = _.get(signS3URL, "tag", "");

          if (progressOfUploads[fileUploadId]) {
            returnUrl = shouldReturnSignedUrl
              ? signS3URL.signedDisplayURL
              : signS3URL.displayURL;

            var signedUrl = signS3URL.uploadURL;

            const headersObj = {
              "Content-Type": attachment.mimeType
                ? attachment.mimeType
                : "application/octet-stream",
              "x-amz-tagging": tag,
            };

            if (signS3URL.enforceIfNoneMatch) {
              headersObj["If-None-Match"] = "*";
            }

            var options = {
              onUploadProgress: e => {
                const progressObject = {
                  id: fileUploadId,
                  progress:
                    startProgressValue +
                    (e.loaded / e.total) * (100.0 - startProgressValue),
                };

                dispatch(setProgress(progressObject));
              },
              headers: headersObj,
              cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                dispatch(setProgress({ id: fileUploadId, cancelToken: c }));
              }),
            };

            return axios.put(signedUrl, file, options);
          } else {
            if (!showProgress) {
              returnUrl = shouldReturnSignedUrl
                ? signS3URL.signedDisplayURL
                : signS3URL.displayURL;
              const signedUrl = signS3URL.uploadURL;

              const headers = {
                "Content-Type": attachment.mimeType
                  ? attachment.mimeType
                  : "application/octet-stream",
                "x-amz-tagging": tag,
              };

              if (signS3URL.enforceIfNoneMatch) {
                headers["If-None-Match"] = "*";
              }

              return axios.put(signedUrl, file, { headers });
            }

            throw "";
          }
        })
        .then(function (result) {
          resolve(returnUrl);
        })
        .catch(function (err) {
          if (showProgress) {
            dispatch(removeProgressElement({ id: fileUploadId }));
          }
          dispatch(setToastMsg("toastMsgs:unable_to_upload"));
          reject(err);
        });
    });

    return { uploadId: fileUploadId, promise: prom };
  };
};

// `notificationCenterOpenMutation`, `notificationCenterReadMutation`, and
// `notificationCenterReadForUserMutation` were moved to
// `src/AppComponents/NotificationCenterV2/modules/NotificationCenterV2Modules.js`.

export const bulkUploadByFile = ({
  url,
  type,
  organizationId,
  inputs,
  refetchQueries = [],
  showMutationErrorMessage = false,
}) => {
  return async (dispatch, getState) => {
    try {
      const userInfo = getUserInfo();
      const response = await client.mutate({
        mutation: bulkUploadByFileMutation,
        variables: {
          url,
          type,
          inputs,
          organizationId: organizationId ? organizationId : userInfo.org_id,
        },
        refetchQueries,
      });
      const bulkUploadFileData = _.get(
        response,
        "data.platform.bulkUploadByFile",
        undefined
      );

      const responseSuccessful = _.get(bulkUploadFileData, "successful", false);

      let returnObject = {
        type: "success",
        msg: "toastMsgs:successfully_with_label",
        locale_params: [
          { key: "label", value: "toastMsgs:added", isPlainText: false },
        ],
      };
      if (!responseSuccessful) {
        if (showMutationErrorMessage)
          returnObject = {
            msg: _.get(bulkUploadFileData, "errors")[0],
            notString: true,
          };
        else returnObject = "toastMsgs:couldnt_be_added";
      }

      dispatch(setToastMsg(returnObject));

      return bulkUploadFileData;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {
        successful: false,
        errors: ["Something went wrong"],
      };
    }
  };
};

export async function detectActualFileType(file) {
  try {
    const header = await file.slice(8, 12).arrayBuffer();
    const bytes = new Uint8Array(header);

    const brand = String.fromCharCode(bytes[0], bytes[1], bytes[2], bytes[3]);

    const heicBrands = new Set([
      "heic",
      "heix",
      "hevc",
      "hevx",
      "mif1",
      "msf1",
    ]);

    return heicBrands.has(brand) ? "image/heic" : "unknown";
  } catch (e) {
    console.error("Error detecting file type:", e);
    return "unknown";
  }
}

export const heicToJpg = ({
  file,
  uploadId,
  startProgress,
  parentType,
  parentId,
  status,
  hideToastProgress = false,
  mimeType = "",
}) => {
  return async (dispatch, getState) => {
    const originalFileType = await detectActualFileType(file);
    const isHeic =
      _.includes(["image/heic", "image/heif"], _.get(file, "type")) ||
      _.includes(["image/heic", "image/heif"], originalFileType) ||
      _.includes(["image/heic", "image/heif"], mimeType) ||
      (_.isEmpty(file?.type) &&
        _.includes(["heif", "heic"], _.toLower(getFileExtension(file?.name)))); //HEIC files can be uploaded from windows

    if (!isHeic || !file || !file?.arrayBuffer) {
      return file;
    }
    const buffer = new Uint8Array(await file.arrayBuffer()); // original file
    if (!isBufferHeic(buffer)) {
      return file;
    }

    try {
      const progressObject = {
        id: uploadId,
        progress: startProgress ? startProgress : 0,
        attachment: file,
        parentType,
        parentId,
        status: status ? status : "PROCESSING",
        startTime: new Date(),
        hideToastProgress,
      };

      dispatch(setProgress(progressObject));

      let convertedBlob = null;

      // * Get converted blob in JPEG formate from HEIC/HEIF
      const getConvertedBlob = async (retryOnChunkLoadError = false) => {
        try {
          const heicConvert = await import(
            /* webpackChunkName: "heic-convert" */
            "heic-convert"
          );

          return await heicConvert.default({
            buffer,
            format: "JPEG", // output format
            quality: 0.8, // JPEG quality (0-1)
          });
        } catch (error) {
          const isChunkLoadError = _.get(error, "name") === "ChunkLoadError";
          if (isChunkLoadError && retryOnChunkLoadError) {
            return await getConvertedBlob(false);
          }
          throw error;
        }
      };

      convertedBlob = await getConvertedBlob(true);

      dispatch(
        removeProgressElement({
          id: uploadId,
        })
      );

      const convertedFilename = _.replace(
        file.name,
        /(\.heic|\.heif)$/i, // regex to replace .heic or .heif with .jpeg
        ".jpeg"
      );

      const convertedFilePath = _.replace(
        file.path,
        /(\.heic|\.heif)$/i, // regex to replace .heic or .heif with .jpeg
        ".jpeg"
      );

      const convertedFile = new File([convertedBlob], convertedFilename, {
        type: "image/jpeg",
        lastModified: Date.now(),
      });

      convertedFile.preview = URL.createObjectURL(convertedFile);
      convertedFile.path = convertedFilePath;

      return convertedFile;
    } catch (e) {
      const fileUrl = await dispatch(
        uploadFileV2({
          file: file,
          attachment: { name: _.get(file, "name", "") },
          uploadId: generateRandomId(),
        })
      );
      dispatch(
        removeProgressElement({
          id: uploadId,
        })
      );
      throw e;
    }
  };
};

export const sendSigninMagicLink = url => {
  return async dispatch => {
    try {
      const mutationData = {
        mutation: sendSigninLinkMutation,
      };
      if (url) {
        mutationData.variables = {
          resourceUrl: url,
          action: "community",
          portalType: "PLANNER",
        };
      }
      await client.mutate(mutationData);
      return true;
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const sendResourceLink = (email, url) => {
  return async (dispatch, getState) => {
    const state = getState();
    const publicToken = _.get(state, "login.publicToken");
    try {
      await axios.post(
        getBackendServerUrl({
          path: `/community/sendResourceUrlEmail`,
        }),
        { emailId: email, resourceUrl: url },
        { headers: { Authorization: `Bearer ${publicToken}` } }
      );
      return true;
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const trackEntityPreview = () => {
  return async (dispatch, getState) => {
    const { utm_token: utmToken, utm_source: platform } = querystringify.parse(
      _.get(window, "location.search", "")
    );
    if (!utmToken && !platform) return false;
    const state = getState();
    const publicToken = _.get(state, "login.publicToken");
    try {
      await axios.post(
        getBackendServerUrl({
          path: `/community/trackPreviews`,
        }),
        { utmToken, platform },
        { headers: { Authorization: `Bearer ${publicToken}` } }
      );
      return true;
    } catch (err) {
      return false;
    }
  };
};

export const createOrganizationGlobalConstants = ({
  organizationId,
  input,
  refetchFilters,
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: createOrganizationGlobalConstantsMutation,
        variables: {
          input,
        },
        refetchQueries: [
          {
            query: getOrganizationGlobalConstantsQuery,
            variables: { organizationId, filter: refetchFilters },
          },
        ],
      });
      return true;
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const getTurnitinReportViewerLaunchUrl = ({ input }) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.query({
        query: getTurnitinReportViewerLaunchUrlQuery,
        variables: {
          input,
        },
        fetchPolicy: "network-only",
      });
      return _.get(
        response,
        "data.integration.getTurnitinReportViewerLaunchUrl",
        ""
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const getIsTurnitinEulaRequired = () => {
  return async (dispatch, getState) => {
    try {
      const response = await client.query({
        query: getIsTurnitinEulaRequiredQuery,
        fetchPolicy: "network-only",
      });
      return _.get(response, "data.integration.isTurnitinEulaRequired", true);
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const acceptTurnitinEula = ({ input }) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: acceptTurnitinEulaMutation,
        variables: { input },
      });
      return response;
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const markAttachmentAsRead = ({ id }) => {
  return async (dispatch, getState) => {
    const attachment = getAttachmentFragmentFromCache({ attachmentId: id });
    writeAttachmentSimilarityReportInCache({
      attachmentId: id,
      data: update(attachment, {
        isRead: { $set: true },
      }),
    });
    try {
      await client.mutate({
        mutation: updateEntityIsReadMutation,
        variables: {
          id: id,
          entityType: "ATTACHMENT",
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const markEntityAsRead = ({ id, type }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateEntityIsReadMutation,
        variables: {
          id: id,
          entityType: type,
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const markEntityAsReadInBulk = ({ input }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateEntityIsReadInBulkMutation,
        variables: {
          input,
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

// `createNestedPlannerFields` and `deletePlannerField` moved to:
// src/routes/routes/Teacher/routes/Courses/routes/Course/routes/UnitPlans/modules/PlannerFieldThunks.js

export const resetAIConversation = variables => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: resetAIConversationMutation,
        variables,
      });

      if (!_.get(response, "isSuccess", true)) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        return;
      }

      return response;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createAIMessage = ({ variables, writeToCache = true }) => {
  return async (dispatch, getState) => {
    const conversation = getAIConversationsFromCache({
      id: _.get(variables, "input.conversationId"),
    });

    const newCreateAiMessage = {
      isSuccess: true,
      response: {
        id: generateRandomId(),
        role: null,
        authorType: _.get(variables, "input.authorType"),
        content: _.get(variables, "input.content"),
        metadata: _.get(variables, "input.metadata"),
        createdBy: null,
        votes: {
          myVote: null,
          __typename: "VoteConnection",
        },
        usageMetricsId: null,
        parentMessage: {
          id: null,
          __typename: "AiMessage",
        },
        __typename: "AiMessage",
      },
      __typename: "GenericAiMessageResponse",
    };

    try {
      return await client.mutate({
        mutation: createAIMessageMutation,
        variables,
        optimisticResponse: {
          __typename: "Mutation",
          ai: {
            __typename: "AiMutations",
            createAiMessage: newCreateAiMessage,
          },
        },
        update: (
          cache,
          {
            data: {
              ai: { createAiMessage },
            },
          }
        ) => {
          if (writeToCache) {
            const createAiMessageNode = {
              node: _.get(createAiMessage, "response"),
              __typename: "AiMessageEdge",
            };

            const dataToSend = update(conversation, {
              messages: {
                edges: {
                  $unshift: [createAiMessageNode],
                },
                totalCount: {
                  $set: _.get(conversation, "messages.totalCount", 0) + 1,
                },
              },
            });

            writeAIConversationsInCache({
              variables: {
                id: _.get(variables, "input.conversationId"),
              },
              data: {
                node: dataToSend,
              },
            });
          }
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateAIMessage = ({ variables, writeToCache = true }) => {
  return async (dispatch, getState) => {
    try {
      return await client.mutate({
        mutation: updateAIMessageMutation,
        variables,
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const getUseAiSdkForRegion = token => {
  try {
    const tokenJson = getDecodedToken(token);
    const region = _.get(tokenJson, "region", "");
    const flag = _.get(AI_SDK_REGION_FLAG_MAP, region, "");
    if (_.isEmpty(flag)) {
      return false;
    }
    return ACLStore.can(flag);
  } catch (e) {
    return false;
  }
};

export const getAIResponse = params => {
  const {
    variables,
    onError,
    getCancelToken,
    onDownloadProgress,
    useStreamParserV2,
  } = params;

  return async (dispatch, getState) => {
    try {
      const state = getState();
      const activeQuestion = _.get(state, "worksheet.activeQuestion");
      const userInfo =
        activeQuestion === GENERATE_USING_AI
          ? getUserInfo({ portalType: "PLANNER" })
          : getUserInfo();
      const token = _.get(userInfo, "token", "");
      const currentCurriculumProgramType = getCurrentCurriculumProgramType(
        getState()
      );
      const useAiSdkForRegion = getUseAiSdkForRegion(token);
      let data = {
        ..._.get(variables, "input", {}),
        token,
        metadata: {
          ..._.get(variables, "input.metadata", {}),
          isCustomAIModerationEnabled: ACLStore.can(
            "FeatureFlag:EnableCustomAIModeration"
          ),
          useStreamParserV2,
          useAiSdk: useAiSdkForRegion,
        },
      };

      if (ACLStore.can("Common:EnableOverrideAIModelOptions")) {
        const promptSetField = currentCurriculumProgramType
          ? `${_.get(data, "entityType", "")}_${currentCurriculumProgramType}`
          : _.get(data, "entityType", "");
        const overriddenModel = getOverriddenModelFromLocalStorage(
          promptSetField
        );
        if (overriddenModel) {
          data.overriddenModel = overriddenModel;
        }
      }

      const entityType = _.get(variables, "input.entityType");

      if (ACLStore.can("Common:EnableAIInputEncryption")) {
        data = await AESEncrypt(JSON.stringify(data));
      }
      const parsedResponse = await makeStreamRequest({
        isChina: isChinaAIEnhancedSetupEnabled({ entityType }),
        functionUrlConfig: {
          url: getStreamBackendUrl({ token, useStreamUrlV2: true }),
          body: { data },
          getCancelToken,
          onDownloadProgress: parsed => onDownloadProgress?.(parsed),
          responseParser: response =>
            parseStreamResponse({ response, useStreamParserV2 }),
        },
        webSocketConfig: {
          url: getWebSocketUrl({ token }),
          data,
          action: "aiResponse",
          getCancelToken,
          onDownloadProgress: parsed => onDownloadProgress?.(parsed),
          responseParser: response =>
            parseStreamResponse({ response, useStreamParserV2 }),
        },
      });

      if (_.get(parsedResponse, "usageLimitExceeded", false)) {
        dispatch(setIsAIUsageLimitModalOpen(true));
      }

      return parsedResponse;
    } catch (e) {
      onError?.();

      if (!axiosLib.isCancel(e) && !isWebSocketCancel(e)) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

/***
 * data: {
    inputText: string, // text to convert to audio
    entityType: string, // entity type where the text is coming from
    entityId: string, // entity id where the text is coming from
    onError: function, // function to call upon error
    curriculumProgramId: string, // curriculum id
 * }
    returns: { audioFileUrl: string } OR { userInputFlagged: true }
 */
export const getTextToSpeechAudio = data => {
  return async dispatch => {
    if (_.isEmpty(data?.inputText)) return;

    const userInfo = getUserInfo();
    const token = _.get(userInfo, "token", "");
    data.token = token;

    let payload = _.omit(_.cloneDeep(data), [
      "setRequestController",
      "onDownloadProgress",
    ]);
    const entityType = _.get(data, "entityType");
    const isChinaAISetupEnabled = isChinaAIEnhancedSetupEnabled({ entityType });
    if (isChinaAISetupEnabled || isAudioServicesChinaSetupEnabled()) {
      payload.model = "toddle-tts-v7";
    } else {
      const defaultModel = getDefaultTTSModel();
      payload.model = !_.isNil(data.model) ? data.model : defaultModel;
    }

    if (ACLStore.can("Common:EnableAIInputEncryption")) {
      payload = await AESEncrypt(JSON.stringify(payload));
    }

    const controller = new AbortController();
    data?.setRequestController?.(controller);
    try {
      const response = await makeStreamRequest({
        isChina: isChinaAISetupEnabled,
        functionUrlConfig: {
          url: getStreamBackendUrl({
            token,
            useStreamUrlV2: true,
            path: "/textToSpeech",
          }),
          body: { data: payload },
          onDownloadProgress: parsed => {
            if (!_.isNil(parsed)) data?.onDownloadProgress?.(parsed);
          },
          responseParser: parseSpeechOperationsResponse,
          axiosConfig: { signal: controller.signal },
        },
        webSocketConfig: {
          url: getWebSocketUrl({ token }),
          data: payload,
          action: "textToSpeech",
          getCancelToken: cancel => {
            data?.setRequestController?.({ abort: cancel });
          },
          onDownloadProgress: parsed => {
            if (!_.isNil(parsed)) data?.onDownloadProgress?.(parsed);
          },
          responseParser: parseSpeechOperationsResponse,
        },
      });

      const streamChunks = response;
      const speechUrl = _.get(
        _.filter(streamChunks, item => _.has(item, "audioFileUrl")),
        [0, "audioFileUrl"],
        ""
      );

      return { streamChunks, speechUrl };
    } catch (e) {
      if (axiosLib.isCancel(e) || isWebSocketCancel(e)) return;
      data?.onError?.(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

/***
 * data: {
    audioFileUrl: string, // audio file url to convert to text
    entityType: string, // entity type where the speech is coming from
    entityId: string, // entity id where the speech is coming from
    onError: function, // function to call upon error
    curriculumProgramId: string, // curriculum id
    model: "toddle-stt-v3"
 * }
    returns: { transcript: string, utterances: Array, durationInSeconds: Integer }
    utterances: [{ startTime: Integer, endTime: Integer, text: string }]
 */
export const getSpeechToTextTranscript = data => {
  return async dispatch => {
    if (_.isEmpty(data?.audioFileUrl) && _.isEmpty(data?.blobAttachment))
      return;

    const userInfo = getUserInfo();
    const token = _.get(userInfo, "token", "");
    data.token = token;

    let payload = _.cloneDeep(data);

    const isChinaAISetupEnabled = isChinaAIEnhancedSetupEnabled({
      entityType: _.get(data, "entityType"),
    });
    const isChinaAudioServicesEnabled = isAudioServicesChinaSetupEnabled();

    if (isChinaAISetupEnabled || isChinaAudioServicesEnabled) {
      payload.model = "toddle-stt-v5";
    } else {
      payload.model = "toddle-stt-v3";
    }

    try {
      if (data?.blobAttachment) {
        if (isChinaAISetupEnabled || isChinaAudioServicesEnabled) {
          const blobFile = _.get(data, "blobAttachment.file");
          const mimeType = _.get(data, "blobAttachment.mimeType", "audio/webm");
          const audioFileUrl = await dispatch(
            uploadFileV2({
              file: blobFile,
              uploadId: generateRandomId(),
              attachment: {
                mimeType,
                metadata: {
                  fileExtension:
                    getFileExtensionFromMimeType({ mimeType }) || "webm",
                },
              },
              hideToastProgress: true,
            })
          );
          payload.audioFileUrl = audioFileUrl;
        } else {
          payload.blobData = await convertRecordedBlobToBase64(
            _.get(data, "blobAttachment.file")
          );
        }
        _.unset(payload, "blobAttachment");
      }

      if (ACLStore.can("Common:EnableAIInputEncryption")) {
        payload = await AESEncrypt(JSON.stringify(payload));
      }

      const speechResponse = await makeStreamRequest({
        isChina: isChinaAISetupEnabled,
        functionUrlConfig: {
          url: getStreamBackendUrl({
            token,
            useStreamUrlV2: true,
            path: "/speechToText",
          }),
          body: { data: payload },
          responseParser: parseSpeechOperationsResponse,
          axiosConfig: { responseType: "application/json" },
        },
        webSocketConfig: {
          url: getWebSocketUrl({ token }),
          data: payload,
          action: "speechToText",
          responseParser: parseSpeechOperationsResponse,
        },
      });

      const transcriptionObject = _.find(speechResponse, item =>
        _.has(item, "transcript")
      );
      if (!transcriptionObject) {
        data?.onError?.(new Error("No transcript found in response"));
        return;
      }

      return transcriptionObject;
    } catch (e) {
      data?.onError?.(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const onAudioFileDownload = attachment => {
  return async dispatch => {
    let name = _.get(attachment, "name", "");

    if (_.isEmpty(name)) {
      name = "toddle_audio_" + moment().format("DD-MM-YY_h_mm");
    }

    const id = "Toddle_audio_#123";

    await dispatch(
      downloadFromUrl({
        name: name,
        attachment: attachment,
        shouldAskForSave: true,
        fileUploadId: id,
      })
    );

    dispatch(removeProgressElement({ id }));
  };
};

export const getGeneratedImageUrl = data => {
  return async dispatch => {
    if (_.isEmpty(data?.inputPrompt)) return;
    const userInfo = getUserInfo();
    const token = _.get(userInfo, "token", "");
    data.token = token;

    let payload = _.cloneDeep(data);
    const entityType = _.get(data, "entityType");
    if (ACLStore.can("Common:EnableAIInputEncryption")) {
      payload = await AESEncrypt(JSON.stringify(data));
    }
    try {
      const imageResponse = await makeStreamRequest({
        isChina: isChinaAIEnhancedSetupEnabled({ entityType }),
        functionUrlConfig: {
          url: getStreamBackendUrl({
            token,
            useStreamUrlV2: true,
            path: "/generateImage",
          }),
          body: { data: payload },
          responseParser: response => JSON.parse(response),
          axiosConfig: { responseType: "application/json" },
        },
        webSocketConfig: {
          url: getWebSocketUrl({ token }),
          data: payload,
          action: "generateImage",
          responseParser: response => JSON.parse(response),
        },
      });
      return imageResponse;
    } catch (e) {
      data?.onError?.(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};
